var map = {
	"./Cheryl.jpg": 2748,
	"./Dustin.jpg": 9666,
	"./Eric.jpg": 9602,
	"./Helen.jpg": 9429,
	"./Hood.jpg": 45,
	"./Ida.jpg": 2659,
	"./Joy.jpg": 8701,
	"./Ricky.jpg": 7405,
	"./Sunny.jpg": 9506,
	"./Wei.jpg": 9490,
	"./default.png": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3623;